import React, { useState } from "react";
import { Button, Modal, Text, Progress, Alert } from "@mantine/core";
import { ApiService } from "../api/api-service";
import { FaSync } from "react-icons/fa";

interface UpdateResult {
  inv_no: string;
  success: boolean;
  message: string;
  updatedClasses?: number;
}

const UpdateHoursButton: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [results, setResults] = useState<UpdateResult[]>([]);
  const [progress, setProgress] = useState(0);

  const updateAllHours = async () => {
    setLoading(true);
    setShowModal(true);
    setResults([]);
    setProgress(0);

    try {
      // Fetch all invoices
      const response = await ApiService.getInstance().get(
        "/tc-invoice-details-trainers",
      );
      const allInvoices = response.data.data;

      // Filter Open and Submitted invoices
      const eligibleInvoices = allInvoices.filter(
        (inv: any) => inv.status === "Open" || inv.status === "Submitted",
      );

      if (eligibleInvoices.length === 0) {
        setResults([
          {
            inv_no: "N/A",
            success: false,
            message: "No Open or Submitted invoices found",
          },
        ]);
        setLoading(false);
        return;
      }

      const updateResults: UpdateResult[] = [];

      // Update each invoice
      for (let i = 0; i < eligibleInvoices.length; i++) {
        const invoice = eligibleInvoices[i];
        try {
          const updateResponse = await ApiService.getInstance().put(
            `/tc-invoice-details-trainers/update-hours/${invoice.inv_no}`,
          );

          updateResults.push({
            inv_no: invoice.inv_no,
            success: true,
            message: updateResponse.data.message,
            updatedClasses: updateResponse.data.updatedClasses,
          });
        } catch (error: any) {
          updateResults.push({
            inv_no: invoice.inv_no,
            success: false,
            message: error.response?.data?.error || "Update failed",
          });
        }

        setProgress(((i + 1) / eligibleInvoices.length) * 100);
      }

      setResults(updateResults);
    } catch (error) {
      console.error("Error updating hours:", error);
      setResults([
        {
          inv_no: "N/A",
          success: false,
          message: "Failed to fetch invoices",
        },
      ]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        leftSection={<FaSync />}
        onClick={updateAllHours}
        loading={loading}
        color="teal"
      >
        Update All Invoices
      </Button>

      <Modal
        opened={showModal}
        onClose={() => setShowModal(false)}
        title="Update Hours Progress"
        size="lg"
      >
        {loading && (
          <>
            <Text mb="sm">Updating invoices...</Text>
            <Progress value={progress} mb="md" />
          </>
        )}

        {!loading && results.length > 0 && (
          <div style={{ maxHeight: "400px", overflowY: "auto" }}>
            {results.map((result, index) => (
              <Alert
                key={index}
                color={result.success ? "green" : "red"}
                mb="sm"
              >
                <Text fw={600}>Invoice: {result.inv_no}</Text>
                <Text size="sm">{result.message}</Text>
                {result.updatedClasses && (
                  <Text size="sm">Updated Hours: {result.updatedClasses}</Text>
                )}
              </Alert>
            ))}
          </div>
        )}
      </Modal>
    </>
  );
};

export default UpdateHoursButton;
